import { MediaOrderBy, MediaService } from "../client"

/* Interfaces */
export interface MediaTableProps {
    searchValue: string
}

export interface DetailMediaProps {
    onClose: () => void
    isOpen: boolean
    mediaId: string
}


/* Endpoints */
export const readMedia = ({
    per_page,
    page,
    order_by,
    descending,
    query,
}: {
    per_page: number,
    page: number
    order_by?: MediaOrderBy
    descending?: boolean
    query?: string
}) => {
    return {
        queryFn: async () => {
        const data = await MediaService.readMedia({
            skip: (page - 1) * per_page,
            limit: per_page,
            orderBy: order_by,
            descending: descending,
            query: query,
        })
            return data ?? { data: null, count: 0 }
        },
        queryKey: ["media", { page, order_by, descending, query }],
    }
}

export const readMediaById = (mediaId: string) => {
    return {
        queryFn: async () => {
            const data = await MediaService.readMediaById({ mediaId: mediaId })

            return data ?? { data: null, count: 0 }
        },
        queryKey: ["media", { mediaId }],
    }
}
